import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { withStyle } from 'styletron-react';
import { StyledPositionLayoutBase, positionLayoutBasePropsToStyledProps, } from './PositionLayoutBase';
const StyledFixedContainer = withStyle(StyledPositionLayoutBase, {
    position: 'fixed',
});
export const FixedContainer = forwardRef(({ children, ...positionLayoutBaseProps }, ref) => {
    return (_jsx(StyledFixedContainer, { ref: ref, ...positionLayoutBasePropsToStyledProps(positionLayoutBaseProps), children: children }));
});
